export default class Term extends React.PureComponent

  constructor: (props) ->
    super(props)

    @editTerm   = @editTerm.bind(this)
    @deleteTerm = @deleteTerm.bind(this)

  editTerm: ->
    @props.editTerm(@props.term)

  deleteTerm: ->
    @props.deleteTerm(@props.term)

  highlight: (text) ->
    highlight.highlightQuery(_.escape(text), @props.query.trim())

  render: ->
    classes = "glossary-term list-group-item"
    classes += " #{@props.flashedClassName}" if @props.flashedClassName

    <div className={classes} id={"term-#{@props.term.id}"}>
      <div className="term-source"
           dir={if @props.sourceRightToLeft then 'rtl' else 'ltr'}
           dangerouslySetInnerHTML={{ __html: @highlight(@props.term.source) }} />

      <div className="term-target">
        <div className="target-text"
             dir={if @props.targetRightToLeft then 'rtl' else 'ltr'}
             dangerouslySetInnerHTML={{ __html: @highlight(@props.term.target) }} />
        {@renderNote()}
      </div>

      <div className="term-actions">
        <i className="fas fa-pencil"
           title="Edit term"
           onClick={@editTerm} />
        <i className="fas fa-xmark"
           title="Remove term"
           onClick={@deleteTerm} />
      </div>
    </div>

  renderNote: ->
    if @props.term.note.length
      <div className="term-note">
        <i className="fa-regular fa-note-sticky"></i> {@props.term.note}
      </div>
